// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"w1-z","disabled":"x1-z","seeAllAnswers":"y1-z"};